import { render, staticRenderFns } from "./RelacaoComCliente.vue?vue&type=template&id=7c10b906&scoped=true"
import script from "./RelacaoComCliente.vue?vue&type=script&lang=js"
export * from "./RelacaoComCliente.vue?vue&type=script&lang=js"
import style0 from "./RelacaoComCliente.vue?vue&type=style&index=0&id=7c10b906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c10b906",
  null
  
)

export default component.exports